import { ComponentProps, useEffect, useRef } from "react"
import { cn } from "styles/cn"

export function ErrorStatus({
	show,
	scroll,
	className,
	children,
	...props
}: ComponentProps<"div"> & { show?: boolean; scroll?: boolean }) {
	const target = useRef<HTMLDivElement>(null)

	useEffect(() => {
		if (show && scroll) {
			target.current?.scrollIntoView({ behavior: "smooth" })
		}
	}, [scroll, show])

	if (!show) {
		return null
	}

	return (
		<div
			{...props}
			ref={target}
			className={cn("flex items-start gap-2 text-sm", className)}
		>
			<div className="mt-1.5 size-1.5 min-w-1.5 rounded-full bg-red-60" />
			{children}
		</div>
	)
}
